<template>
  <div class="my-item">
    <div class="custom-wrap">
      <template v-if="list && list.length">
        <Table
          :border="false"
          row-key="id"
          :columns="columns1"
          :data="list"
          :load-data="handleLoadData"
          max-height="700"
        >
          <template slot-scope="{ row }" slot="isNeedFile">{{row.isNeedFile?'是':'否'}}</template>
          <template slot-scope="{ row }" slot="action">
            <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
            <span style="display: inline-block;padding: 0 5px;">|</span>
            <span
              style="color: #1890ff;cursor: pointer;"
              @click="editSubShow(row)"
              v-if="row.type === 1"
            >添加子项</span>
            <span
              style="display: inline-block;padding: 0 5px;"
              v-if="row.type === 1"
            >|</span>
            <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
              <span style="color: #f00;cursor: pointer;">删除</span>
            </Poptip>
          </template>
        </Table>
      </template>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
    <authAdd
      :show="show"
      @finish="init()"
      @close="show=false;"
      :options="options"
      :modelTitle="modelTitle"
    />
    <authAddChild
      :show="showChild"
      @finish="init()"
      @close="showChild=false;"
      :options="optionsChild"
      :modelTitle="modelTitle"
    />
  </div>
</template>

<script>
import authAdd from "../components/auth-add.vue";
import authAddChild from "../components/auth-child-add.vue";
import { mapActions } from "vuex";

export default {
  // 主办设置
  name: "host-set",
  data() {
    return {
      list: null, 
      edit: false,
      editInfo: false,
      show: false, 
      options:{}, 
      modelTitle:'',
      showChild: false, 
      optionsChild:{},
      columns1: [
        {
          title: "产品认证",
          key: "name",
          tree: true
        },
        {
          title: "英文名称",
          key: "nameEn"
        },
        {
          title: "是否需要上传认证文件",
          slot: "isNeedFile",
          key: "isNeedFile",
          align: "center"
        },
        {
          title: "排序",
          key: "showIndex",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ]
    };
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  created() {
    this.init();
  },
  components: {
    authAdd,
    authAddChild,
  },
  methods: {
    ...mapActions({
      getBusinessTypeList:'hostSetModule/getBusinessTypeList',
      delBusType:'hostSetModule/delBusType',
    }),
    getChildList(item) {
      if (!item) return [];
      const childList = item.list || item.List;
      return Array.isArray(childList) ? childList : [];
    },
    markTreeNode(item, type) {
      item.type = type;
      const childList = this.getChildList(item);
      item.num = childList.length;
      if (item.num) {
        item.children = [];
        item._loading = false;
      }
    },
    async init() {
      let url = '/api/ProAuth/GetListByParentId';
      let listData = await this.getBusinessTypeList(url);
      if (listData && listData.length) {
        listData.map(c => {
          this.markTreeNode(c, 1);
        });
        this.list = listData;
      } else {
        this.list = [];
      }
      console.log("认证信息：",this.list)
    },
    handleLoadData(item, callback) {
      const list = JSON.parse(JSON.stringify(this.getChildList(item)));
      list.map(c => {
        this.markTreeNode(c, item.type + 1);
      });
      callback(list);
    },
    async delItem(item) { 
      let opt = {
         url: '/api/ProAuth',
         id:item.id
      }
      let result = await this.delBusType(opt);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    showAdd() { // 新增
      this.show = true;
      this.modelTitle = '新增';
      this.options = {
        model:null,
        msg:null,
      }
    },
    editShow(item) { // 编辑
      this.show = true;
      this.modelTitle = '编辑';
      this.options = {
        model:'edit',
        msg:item,
      }
    },
    editSubShow(item){
      this.showChild = true;
      this.modelTitle = '新增子项目';
      this.optionsChild = {
        model:'edit',
        msg:item,
      }
    }
  }
};
</script>

<style scoped lang="scss">
.custom-wrap {
  margin: 0 auto;
  min-height: 500px;
} 
</style>
